import React, { createContext, useContext, useMemo, useState } from 'react';

const AppStateContext = createContext(null);

export function AppStateProvider({ children }) {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [tabletRailCollapsed, setTabletRailCollapsed] = useState(true);

  const value = useMemo(
    () => ({
      mobileNavOpen,
      setMobileNavOpen,
      tabletRailCollapsed,
      setTabletRailCollapsed,
    }),
    [mobileNavOpen, tabletRailCollapsed]
  );

  return <AppStateContext.Provider value={value}>{children}</AppStateContext.Provider>;
}

export function useAppState() {
  const context = useContext(AppStateContext);
  if (!context) {
    throw new Error('useAppState must be used within AppStateProvider');
  }
  return context;
}
